import { render, staticRenderFns } from "./DeletedUsers.vue?vue&type=template&id=59a2056f"
import script from "./DeletedUsers.vue?vue&type=script&lang=js"
export * from "./DeletedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a2056f')) {
      api.createRecord('59a2056f', component.options)
    } else {
      api.reload('59a2056f', component.options)
    }
    module.hot.accept("./DeletedUsers.vue?vue&type=template&id=59a2056f", function () {
      api.rerender('59a2056f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Users/DeletedUsers.vue"
export default component.exports